import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LineBotService {

  constructor(private http: HttpRequestService) { }

  getAll(parameters) {
    return this.http.get('line-bot-account/all', parameters)
      .map(res => {
        return res.json();
      });
  }

  // search list line bot
  gets(parameters) {
    return this.http.get('line-bot-account/search', parameters)
      .map(res => {
        return res.json();
      });
  }

  save(model: any) {
    return this.http.post('line-bot-account', model)
      .map(res => {
        return res.json();
      });
  }

  // delete line bot
  delete(id: string) {
    return this.http.delete(`line-bot-account?id=${id}`).map(res => {
      return res.json();
    });
  }

  // toggle
  active(model: any) {
    return this.http.put(`line-bot-account/active`, model).map(res => {
      return res.json();
    });
  }

  getLineBot() : Observable<any[]>{
    return this.http.get(`line-bot-account/linebot`)
      .map(res => {
          return res.json()
      });
  }

  getAllBotConnected() : Observable<any[]>{
    return this.http.get(`line-bot-account/getAllBotConnected`)
      .map(res => {
          return res.json()
      });
  }

  getLineBotAlls() : Observable<any[]>{
    return this.http.get(`line-bot-account/linebotAll`)
        .map(res => {
          return res.json()
        });
  }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/line-bot.service.ts